import { render } from "./FeatureNotAvailable.vue?vue&type=template&id=ac185310&scoped=true"
import script from "./FeatureNotAvailable.vue?vue&type=script&lang=js"
export * from "./FeatureNotAvailable.vue?vue&type=script&lang=js"

import "./FeatureNotAvailable.vue?vue&type=style&index=0&id=ac185310&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac185310"]])

export default __exports__